import { render, staticRenderFns } from "./LoginUniversalEntryPoint.vue?vue&type=template&id=40662b7f&"
import script from "./LoginUniversalEntryPoint.vue?vue&type=script&lang=ts&"
export * from "./LoginUniversalEntryPoint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports